import { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageHeader, Loading, EmptyState } from "../../components/shared";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { ClipboardList } from "lucide-react";

export default function AdminRequirements() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/requirements").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loading />;
  return (
    <div>
      <PageHeader title="Requirements" subtitle="Service requirements across all societies." />
      {rows.length === 0 ? <EmptyState icon={ClipboardList} title="No requirements yet" /> : (
        <div className="bg-card border rounded-xl overflow-hidden overflow-x-auto">
          <Table>
            <TableHeader><TableRow><TableHead>Ref</TableHead><TableHead>Society</TableHead><TableHead>Title</TableHead><TableHead>Category</TableHead><TableHead>Urgency</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.requirement_id}>
                  <TableCell className="font-mono text-sm">{r.ref}</TableCell><TableCell>{r.society_name}</TableCell><TableCell className="font-medium">{r.title}</TableCell>
                  <TableCell>{r.category}</TableCell><TableCell>{r.urgency}</TableCell>
                  <TableCell><span className="text-xs rounded-full bg-primary/10 text-primary px-2 py-0.5">{r.status}</span></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
